import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
    const { status } = useAuth();
    const location = useLocation();

    if (status === "loading") {
        return (
            <div
                className="flex h-screen flex-col items-center justify-center gap-4 bg-white"
                data-testid="auth-loading"
            >
                <img
                    src="/brand/yugos-logo.png"
                    alt="YugOS"
                    width={44}
                    height={44}
                    className="animate-pulse select-none"
                    draggable={false}
                />
                <Loader2 className="h-4 w-4 animate-spin text-zinc-400" strokeWidth={1.5} />
            </div>
        );
    }
    if (status === "anon") {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return children;
}
